import { graphql } from '@/gql';
import type { CancelPaymentIntentForGiftCardsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelPaymentIntentForGiftCards = async ({
  userId,
  paymentIntentId,
}: CancelPaymentIntentForGiftCardsMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation cancelPaymentIntentForGiftCards($userId: String!, $paymentIntentId: String!) {
        cancelPaymentIntentForGiftCards(userId: $userId, paymentIntentId: $paymentIntentId)
      }
    `),
    variables: {
      userId,
      paymentIntentId,
    },
  });

  return response.data?.cancelPaymentIntentForGiftCards ?? false;
};
